import type { MouseEvent } from "react";

/** Open a list row on click, without breaking the things a row still has to do.

    A whole-row click target is what makes a list usable, but the rows carry
    email addresses and titles people copy out of them: navigating on the
    ``click`` that ends a drag-select throws the selection away and replaces the
    page. Modifier clicks belong to the browser (new tab, new window, extend
    selection), so they are left alone - the row's own anchor carries the href,
    so cmd-click on the link still opens a tab. */
export const rowClickHandler =
  (open: () => void) =>
  (event: MouseEvent): void => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if ((window.getSelection()?.toString() ?? "") !== "") return;
    open();
  };
